<template>
  <div>
    <div class="service width1200">
      <el-row>
        <el-col :span="4">
          <el-menu ref="menu" :default-active="this.$route.path" class="el-menu-vertical-demo" router>
            <el-menu-item index="/service/access">
              <span slot="title">入网查询</span>
            </el-menu-item>
            <el-menu-item index="/service">
              <span slot="title">定位查询</span>
            </el-menu-item>
            <el-menu-item index="/service/locus">
              <span slot="title">轨迹查询</span>
            </el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <span>电子合同</span>
              </template>
              <el-menu-item index="/service/defend">
                <span slot="title">信息维护</span>
              </el-menu-item>
              <el-menu-item index="/service/commission">
                <span slot="title">委托协议</span>
              </el-menu-item>
              <el-menu-item index="/service/add">
                <span slot="title">创建合同</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/service/insurance">
              <span slot="title">电子保单</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="20">
          <div class="serviceBody bgf5">
            <router-view></router-view>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      handleOpen() {
        console.log();
      },
      handleClose() {
        console.log();
      }
    }
  }
</script>

<style lang="scss">
  .service {
    .el-menu-vertical-demo {
      margin-top: 20px;
    }

    .el-menu-item,
    .el-submenu__title {
      text-align: left;
    }

    &Body {
      padding: 16px 12px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service.vue